import React from 'react';
import { Accordion } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { validationClasses } from '@/utils/errors';
import { hasMinimumLength } from '@/utils/resultsHelper';
import AccordionHeader from '@/components/accordion/AccordionHeader';
import QueryDictionaryButtons from '../../queries/containers/QueryDictionaryButtons';
import QueryClausesTables from './QueryClausesTable';
import { canEditCohort } from '../../helper';
import ClausesCounts from '../../profile/components/ClausesCounts';
import { findQueryDictionary } from '../../state/shared';

const QueryClausesAccordion = ({
  active,
  index,
  onClick,
  name,
  code,
  category,
  dictionaryCode,
  canEdit,
  queryUUID,
  validationErrors,
  saveErrors,
  clauseCount,
}) => {
  const validationError = active ? undefined : saveErrors.find((e) => (
    e.context.queryUUID === queryUUID && e.context.dictionaryCode === dictionaryCode));
  const hasDictionary = hasMinimumLength(name);
  const showCounts = hasDictionary && (active ? clauseCount > 1 : clauseCount > 0);

  return (
    <>
      <AccordionHeader
        active={active}
        error={!hasDictionary}
        index={index}
        headerText={hasDictionary ? name : undefined}
        headerId={hasDictionary ? undefined : 'unknown'}
        onClick={hasDictionary ? onClick : undefined}
        className={validationClasses(validationError, 'aridhia-query-dictionary-accordion-header')}
      >
        <div className="float-r">
          {canEdit && (
            <QueryDictionaryButtons
              code={code}
              category={category}
              queryUUID={queryUUID}
              dictionaryCode={dictionaryCode}
            />
          )}
          {showCounts && (
          <ClausesCounts
            category={category}
            code={code}
            queryUUID={queryUUID}
            dictionaryCode={dictionaryCode}
            hideEntities={!active}
          />
          )}
        </div>
      </AccordionHeader>
      {active && (
      <Accordion.Content active={active} className="aridhia-query-dictionary-accordion-content">
        <QueryClausesTables
          code={code}
          category={category}
          dictionaryCode={dictionaryCode}
          queryUUID={queryUUID}
          validationErrors={validationErrors}
        />
      </Accordion.Content>
      )}
    </>
  );
};

export const mapStateToProps = ({
  cohorts: {
    cohorts,
  },
  auth: {
    role,
  },
}, ownProps) => {
  const { cohort, dictionary, clauses } = findQueryDictionary(cohorts, ownProps);

  return {
    name: dictionary?.name,
    saveErrors: cohort.saveErrors,
    validationErrors: cohort.validationErrors,
    canEdit: canEditCohort(cohort, role),
    clauseCount: clauses.filter((r) => (!r.isNew)).length,
  };
};

export default connect(mapStateToProps)(QueryClausesAccordion);
